var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[(_vm.show)?_c('div',{staticClass:"toast-container",on:{"click":_vm.close}},[_c('div',{staticClass:"toast"},[_c('span',{staticClass:"toast-text"},[_vm._v(_vm._s(_vm.message))])])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }